"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BallScrew = void 0;
const two_js_1 = __importDefault(require("two.js"));
const BallScrewElement_1 = require("./BallScrewElement");
const QuatableElement_1 = require("./QuatableElement");
const Screw_1 = require("./Screw");
const Snail_1 = require("./Snail");
const Rows_1 = require("./Rows");
const terminalT3_1 = require("./terminals/terminalT3");
const terminalT4_1 = require("./terminals/terminalT4");
const terminalT1_1 = require("./terminals/terminalT1");
const terminalT2_1 = require("./terminals/terminalT2");
/**
 * Class to draw a complete BallScrew
 */
class BallScrew extends QuatableElement_1.QuotableElement {
    /**
     * Constructor
     * @param type
     */
    constructor(type = String(BallScrew.DrawerStyle.DRAWER)) {
        super();
        // Current drawer style
        this.draweStyle = String(BallScrew.DrawerStyle.DRAWER);
        // Array of BallScrewElement registered to hide or show quotes
        this.elementsToQuotes = [];
        // Maximum scale factor
        this.maxScaleFactor = 13;
        // Current scale factor
        this.scaleFactor = 1.5;
        // HTMLObject of current canvas
        this.elem = null;
        // Selected record of ball screw draw on canvas
        this.selected = null;
        // Global configuration record
        this.configuration = null;
        // Total ballscrew width
        this.totalBallScrewWidth = 0;
        // Total ballscrew height
        this.correctHeight = 0;
        // Base configuration
        this.ballScrewData = {
            ballScrew: null,
            left_terminal_object: null,
            left_terminal_record: null,
            right_terminal_object: null,
            right_terminal_record: null,
            screw: null,
            screwWidth: null,
            snail: Snail_1.Snail,
        };
        this.quoteTotal = {
            bottom: null,
            left: null,
            left_row: null,
            right: null,
            right_row: null,
            text: null,
        };
        this.draweStyle = type;
    }
    get quoteScale() {
        return ((this.selected.D6 * this.scaleFactor) / 2) / 60;
    }
    get totalLenght() {
        let totalLenght = this.configuration.configuration.screwLength;
        if (this.ballScrewData.left_terminal_record != null) {
            totalLenght += this.getTerminalWidth(this.ballScrewData.left_terminal_record, false);
        }
        if (this.ballScrewData.right_terminal_record != null) {
            totalLenght += this.getTerminalWidth(this.ballScrewData.right_terminal_record, false);
        }
        return totalLenght;
    }
    /**
     * Function to draw entire ballscrew
     * @param two instance of two.js
     * @param elem HTMLNode element
     * @param configuration record of configuration to draw
     */
    draw(two, elem, selectedBallScrew, configuration, correctWidth, canvasWidth = null) {
        this.elem = elem;
        this.two = two;
        this.selected = selectedBallScrew;
        this.configuration = configuration;
        // Save terminal to draw
        if (configuration.left_terminal_record != null || configuration.right_terminal_record != null) {
            this.ballScrewData.left_terminal_record = configuration.left_terminal_record;
            this.ballScrewData.right_terminal_record = configuration.right_terminal_record;
        }
        else if (configuration.left_terminal != null || configuration.right_terminal != null) {
            this.ballScrewData.left_terminal_record = configuration.left_terminal;
            this.ballScrewData.right_terminal_record = configuration.right_terminal;
        }
        if (this.ballScrewData.left_terminal_record == null) {
            this.ballScrewData.left_terminal_object = null;
        }
        if (this.ballScrewData.right_terminal_record == null) {
            this.ballScrewData.right_terminal_object = null;
        }
        // Clear elements to quote
        this.elementsToQuotes.length = 0;
        // Calculate 1/4 of width as a correct height
        this.correctHeight = correctWidth / 4;
        // Get actual canvas width
        const actualWidth = canvasWidth || $(this.elem).width();
        // Calculate scale factor
        this.scaleFactor = Math.min(this.correctHeight / this.selected.nominal_diameter, this.maxScaleFactor);
        // Calculate minimum width needed
        const scaledL14 = this.selected.L14 * this.scaleFactor;
        this.ballScrewData.screwWidth = scaledL14 + (this.correctHeight);
        // Calculate total width before apply new scale factor
        this.recalculateTotalWidth();
        // Add correction scale
        if (this.totalBallScrewWidth > actualWidth - 200) {
            this.scaleFactor *= (actualWidth - 200) / this.totalBallScrewWidth;
            this.correctHeight = this.selected.nominal_diameter * this.scaleFactor;
            const reScaledL14 = this.selected.L14 * this.scaleFactor;
            this.ballScrewData.screwWidth = reScaledL14 + (this.correctHeight);
        }
        // Recalculate new width with new scale factor
        this.recalculateTotalWidth();
        // Create screw
        const screw = new Screw_1.Screw(this.two, this.ballScrewData.screwWidth, this.correctHeight, this.selected.root_diameter * this.scaleFactor, this.selected, this.configuration);
        this.ballScrewData.screw = screw.draw();
        this.elementsToQuotes.push(screw);
        // Create general Group
        this.ballScrewData.ballScrew = this.two.makeGroup();
        // Add screw
        this.ballScrewData.screw.translation.set((this.elem.offsetWidth / 2) - (this.ballScrewData.screwWidth / 2), this.elem.offsetHeight / 2);
        this.ballScrewData.ballScrew.add(this.ballScrewData.screw);
        // Add snail
        const snailObj = new Snail_1.Snail(this.two);
        this.ballScrewData.snail = snailObj;
        this.elementsToQuotes.push(this.ballScrewData.snail);
        this.ballScrewData.snail = this.ballScrewData.snail.drawLinear(this.two, this.correctHeight, this.selected.balls_diameter * this.scaleFactor, this.selected.D1 * this.scaleFactor, this.selected.D6 * this.scaleFactor, this.selected.L3 * this.scaleFactor, this.selected.L7 * this.scaleFactor, this.selected.L1 * this.scaleFactor, (this.selected.L14 - (this.selected.L3 + this.selected.L7 + this.selected.L1)) * this.scaleFactor, this.selected);
        // Draw only for PDF document
        if (this.draweStyle === String(BallScrew.DrawerStyle.DOCUMENT)) {
            snailObj.drawCustomerIdentifyQuote();
        }
        this.ballScrewData.snail.translation.set((this.elem.offsetWidth / 2) - ((this.selected.L14 * this.scaleFactor) / 2), this.elem.offsetHeight / 2);
        this.ballScrewData.ballScrew.add(this.ballScrewData.snail);
        if (this.ballScrewData.left_terminal_record != null) {
            this.addTerminal(this.ballScrewData.left_terminal_record, "left");
        }
        if (this.ballScrewData.right_terminal_record != null) {
            this.addTerminal(this.ballScrewData.right_terminal_record, "right");
        }
        const center = (this.elem.offsetWidth / 2);
        this.ballScrewData.ballScrew.add(Rows_1.Rows.draw(this.two, center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 5, this.ballScrewData.screw.translation.y, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 5, this.ballScrewData.screw.translation.y, Rows_1.RowsStyle.Axis));
        if (this.configuration.configuration != null && this.configuration.configuration.screwLength > 0) {
            this.drawTotalQuote();
        }
        // Draw only for PDF document
        if (this.draweStyle === String(BallScrew.DrawerStyle.DOCUMENT)) {
            this.drawHoleIndicator();
        }
        return this.ballScrewData.ballScrew;
    }
    addElementsToQuote(elem) {
        this.elementsToQuotes.push(elem);
    }
    removeTerminals() {
        this.ballScrewData.left_terminal_record = null;
        this.ballScrewData.right_terminal_record = null;
    }
    /**
     * drawHoleIndicator
     */
    drawHoleIndicator() {
        const center = (this.elem.offsetWidth / 2);
        let socketName = this.getSocketName(this.configuration.configuration.socket_left, "left");
        const holeQuoteLeft = Rows_1.Rows.draw(this.two, center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y, center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 30, this.ballScrewData.screw.translation.y - (this.correctHeight / 2), Rows_1.RowsStyle.Thread);
        holeQuoteLeft.stroke = "#000000";
        this.ballScrewData.ballScrew.add(holeQuoteLeft);
        const holeQuoteLeftVert = Rows_1.Rows.draw(this.two, center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 30, this.ballScrewData.screw.translation.y - (this.correctHeight / 2), center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 30, this.ballScrewData.screw.translation.y - (this.correctHeight / 2) - socketName[1], Rows_1.RowsStyle.Thread);
        holeQuoteLeftVert.stroke = "#000000";
        this.ballScrewData.ballScrew.add(holeQuoteLeftVert);
        const holeTextLeft = this.two.makeText(socketName[0], center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 38, this.ballScrewData.screw.translation.y - (this.correctHeight / 2) - 10, QuatableElement_1.QuotableElement.STYLE_LEFT);
        holeTextLeft.fill = "#000000";
        holeTextLeft.rotation = -Math.PI / 2;
        this.ballScrewData.ballScrew.add(holeTextLeft);
        const holeLeftRow = Rows_1.Rows.makeArrow("down");
        holeLeftRow.translation.set(center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 12, this.ballScrewData.screw.translation.y - 5);
        holeLeftRow.rotation = -(Math.PI / 5);
        this.ballScrewData.ballScrew.add(holeLeftRow);
        socketName = this.getSocketName(this.configuration.configuration.socket_right, "right");
        const holeQuoteRight = Rows_1.Rows.draw(this.two, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 35, this.ballScrewData.screw.translation.y - (this.correctHeight / 2), Rows_1.RowsStyle.Thread);
        holeQuoteRight.stroke = "#000000";
        this.ballScrewData.ballScrew.add(holeQuoteRight);
        const holeQuoteRightVert = Rows_1.Rows.draw(this.two, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 35, this.ballScrewData.screw.translation.y - (this.correctHeight / 2), center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 35, this.ballScrewData.screw.translation.y - (this.correctHeight / 2) - socketName[1], Rows_1.RowsStyle.Thread);
        holeQuoteRightVert.stroke = "#000000";
        this.ballScrewData.ballScrew.add(holeQuoteRightVert);
        const holeTextRight = this.two.makeText(socketName[0], center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 28, this.ballScrewData.screw.translation.y - (this.correctHeight / 2) - 10, QuatableElement_1.QuotableElement.STYLE_LEFT);
        holeTextRight.fill = "#000000";
        holeTextRight.rotation = -Math.PI / 2;
        this.ballScrewData.ballScrew.add(holeTextRight);
        const holeRightRow = Rows_1.Rows.makeArrow("down");
        holeRightRow.translation.set(center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x + 1, this.ballScrewData.screw.translation.y - 12);
        holeRightRow.rotation = Math.PI / 5;
        this.ballScrewData.ballScrew.add(holeRightRow);
    }
    getSocketName(socket, position) {
        switch (socket) {
            case "f2":
                const indicatorz = (position === "right") ?
                    this.configuration.right_terminal.Z : this.configuration.left_terminal.Z;
                return ["HEX " + parseFloat(indicatorz.toString()).toFixed(0).toString(), 50];
            case "f1":
                const indicator = (position === "right") ?
                    this.configuration.right_terminal.M : this.configuration.left_terminal.M;
                return ["UNI 9321/DIN 332-D " + indicator, 130];
            case "f0":
                return ["CENTRE HOLE PERMITTED ", 110];
        }
    }
    /**
     * Recalculate total width
     */
    recalculateTotalWidth() {
        // Calculate scale factor
        this.totalBallScrewWidth = this.ballScrewData.screwWidth;
        if (this.ballScrewData.right_terminal_record != null) {
            this.totalBallScrewWidth += this.getTerminalWidth(this.ballScrewData.right_terminal_record);
        }
        if (this.ballScrewData.left_terminal_record != null) {
            this.totalBallScrewWidth += this.getTerminalWidth(this.ballScrewData.left_terminal_record);
        }
    }
    /**
     * Return terminal number
     */
    getTernimalNumber() {
        let tot = 0;
        if (this.ballScrewData.right_terminal_record != null) {
            tot++;
        }
        if (this.ballScrewData.left_terminal_record != null) {
            tot++;
        }
        return tot;
    }
    /**
     * Add terminal to current Ball Screw
     * @param item
     * @param position
     */
    addTerminal(item, position) {
        const type = this.getTerminalImageName(item.code).toLowerCase();
        // Save terminal record
        if (position === "right") {
            this.ballScrewData.right_terminal_record = item;
        }
        else {
            this.ballScrewData.left_terminal_record = item;
        }
        let tWidth = item.W * this.scaleFactor;
        let terminal = null;
        switch (type) {
            case "t0":
                terminal = new two_js_1.default.Group();
                break;
            case "t1":
                const newTerminalT1112 = new terminalT1_1.TerminalT1(this.two, item.d * this.scaleFactor, tWidth, item.W1 * this.scaleFactor, item.d4 * this.scaleFactor, item.W3 * this.scaleFactor, item.RFd5 * this.scaleFactor, item, position);
                newTerminalT1112.scaleFactor = this.scaleFactor;
                this.elementsToQuotes.push(newTerminalT1112);
                terminal = newTerminalT1112.draw();
                this.ballScrewData.ballScrew.add(terminal);
                tWidth += (item.W1 * this.scaleFactor);
                break;
            case "t2":
                const newTerminalt2122 = new terminalT2_1.TerminalT2(this.two, item.d * this.scaleFactor, tWidth, item.W3 * this.scaleFactor, item.RFd5 * this.scaleFactor, item, position);
                newTerminalt2122.scaleFactor = this.scaleFactor;
                this.elementsToQuotes.push(newTerminalt2122);
                terminal = newTerminalt2122.draw();
                this.ballScrewData.ballScrew.add(terminal);
                tWidth += (item.W1 * this.scaleFactor);
                break;
            case "t4":
                const newTerminal4142 = new terminalT4_1.TerminalT4(this.two, item.d * this.scaleFactor, tWidth, item.W1 * this.scaleFactor, item.d4 * this.scaleFactor, item.W3 * this.scaleFactor, item.RFd5 * this.scaleFactor, item, position, item.B * this.scaleFactor, item.L * this.scaleFactor, item.T * this.scaleFactor);
                newTerminal4142.scaleFactor = this.scaleFactor;
                this.elementsToQuotes.push(newTerminal4142);
                terminal = newTerminal4142.draw();
                this.ballScrewData.ballScrew.add(terminal);
                tWidth += (item.W1 * this.scaleFactor);
                break;
            case "t3":
                const newTerminalt31 = new terminalT3_1.TerminalT3(this.two, item.d * this.scaleFactor, tWidth, item.W2 * this.scaleFactor, item.W4 * this.scaleFactor, item, position);
                newTerminalt31.scaleFactor = this.scaleFactor;
                this.elementsToQuotes.push(newTerminalt31);
                terminal = newTerminalt31.draw();
                this.ballScrewData.ballScrew.add(terminal);
                break;
        }
        // Add translation based on added terminals
        if (position === "right") {
            this.ballScrewData.right_terminal_object = terminal;
            this.ballScrewData.ballScrew.translation.x -= tWidth / 2;
            terminal.translation.set(this.ballScrewData.screw.translation.x + this.ballScrewData.screwWidth, this.ballScrewData.screw.translation.y);
        }
        else {
            this.ballScrewData.left_terminal_object = terminal;
            this.ballScrewData.ballScrew.translation.x += tWidth / 2;
            terminal.translation.set(this.ballScrewData.screw.translation.x, this.ballScrewData.screw.translation.y);
            terminal.rotation = Math.PI;
        }
        this.two.update();
    }
    /**
     * Show all quotes on canvas
     */
    showAllQuotes() {
        for (const elm of this.elementsToQuotes) {
            elm.showQuotes(this.quoteScale);
        }
    }
    /**
     * Hide all quotes on canvas
     */
    hideAllQuotes() {
        for (const elm of this.elementsToQuotes) {
            elm.hideQuotes();
        }
    }
    /**
     * Get terminal image name based on code
     * @param code
     * @return string
     */
    getTerminalImageName(code) {
        return code.substr(0, 2).toLowerCase();
    }
    /**
     * Return all ballscrew calculated data
     * @return any
     */
    getData() {
        return this.ballScrewData;
    }
    /**
     * Get external part terminal height
     */
    getTerminalHeightExternal(item) {
        const type = this.getTerminalImageName(item.code).toLowerCase();
        switch (type) {
            case "t0":
                return 0;
            case "t1":
                return item.d4 * this.scaleFactor;
            case "t2":
                return item.d * this.scaleFactor;
            case "t4":
                return item.d4 * this.scaleFactor;
            case "t3":
                return item.d * this.scaleFactor;
        }
    }
    /**
     * Get real width of passed terminal record
     * @param item
     * @return float
     */
    getTerminalWidth(item, scaled = true) {
        if (item == null) {
            return 0;
        }
        const type = this.getTerminalImageName(item.code).toLowerCase();
        const toScale = scaled ? this.scaleFactor : 1;
        const tWidth = item.W * toScale;
        switch (type) {
            case "t0":
                return 0;
            case "t1":
                return tWidth + (item.W1 * toScale);
            case "t2":
                return tWidth + (item.W1 * toScale);
            case "t4":
                return tWidth + (item.W1 * toScale);
            case "t3":
                return tWidth;
        }
    }
    /**
     * Return total ballscrew width
     * @return tuple
     */
    getDimensions() {
        return [this.totalBallScrewWidth, this.correctHeight];
    }
    /**
     * Return the scale factor
     * @return number
     */
    getScaleFactor() {
        return this.scaleFactor;
    }
    hideTotalQuote() {
        this.ballScrewData.BallScrew.remove(this.quoteTotal.left);
        this.ballScrewData.BallScrew.remove(this.quoteTotal.right);
        this.ballScrewData.BallScrew.remove(this.quoteTotal.bottom);
        this.ballScrewData.BallScrew.remove(this.quoteTotal.text);
        this.ballScrewData.BallScrew.remove(this.quoteTotal.left_row);
        this.ballScrewData.BallScrew.remove(this.quoteTotal.right_row);
        this.two.update();
    }
    /**
     * Function to draw total quote
     */
    drawTotalQuote() {
        const center = (this.elem.offsetWidth / 2);
        let heightFromCenterLeft = this.correctHeight;
        let heightFromCenterRight = this.correctHeight;
        if (this.ballScrewData.left_terminal_record != null) {
            heightFromCenterLeft = this.getTerminalHeightExternal(this.ballScrewData.left_terminal_record);
        }
        if (this.ballScrewData.right_terminal_record != null) {
            heightFromCenterRight = this.getTerminalHeightExternal(this.ballScrewData.right_terminal_record);
        }
        const leftYquote = this.ballScrewData.screw.translation.y + (heightFromCenterLeft / 2) + 3;
        const rightYquote = this.ballScrewData.screw.translation.y + (heightFromCenterRight / 2) + 3;
        this.quoteTotal.left = this.two.makeLine(center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, leftYquote, center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y + 160 * this.quoteScale);
        this.quoteTotal.left.linewidth = 0.5;
        this.quoteTotal.left.stroke = BallScrewElement_1.BallScrewElement.COLORQUOTE;
        this.ballScrewData.ballScrew.add(this.quoteTotal.left);
        this.quoteTotal.right = this.two.makeLine(center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, rightYquote, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y + 160 * this.quoteScale);
        this.quoteTotal.right.linewidth = 0.5;
        this.quoteTotal.right.stroke = BallScrewElement_1.BallScrewElement.COLORQUOTE;
        this.ballScrewData.ballScrew.add(this.quoteTotal.right);
        this.quoteTotal.bottom = this.two.makeLine(center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y + 160 * this.quoteScale - 10, center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x, this.ballScrewData.screw.translation.y + 160 * this.quoteScale - 10);
        this.quoteTotal.bottom.linewidth = 0.5;
        this.quoteTotal.bottom.stroke = BallScrewElement_1.BallScrewElement.COLORQUOTE;
        this.ballScrewData.ballScrew.add(this.quoteTotal.bottom);
        this.quoteTotal.left_row = Rows_1.Rows.makeArrow("left");
        this.quoteTotal.left_row.translation.set(center - this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 3, this.ballScrewData.screw.translation.y + 160 * this.quoteScale - 17);
        this.ballScrewData.ballScrew.add(this.quoteTotal.left_row);
        this.quoteTotal.right_row = Rows_1.Rows.makeArrow("right");
        this.quoteTotal.right_row.translation.set(center + this.totalBallScrewWidth / 2 - this.ballScrewData.ballScrew.translation.x - 10, this.ballScrewData.screw.translation.y + 160 * this.quoteScale - 17);
        this.ballScrewData.ballScrew.add(this.quoteTotal.right_row);
        const leftRightGap = (this.quoteTotal.right.vertices[0].x - this.quoteTotal.left.vertices[0].x);
        this.quoteTotal.text = this.two.makeText("TOTAL LENGTH: " + this.totalLenght, this.quoteTotal.left.vertices[0].x + (leftRightGap / 2), this.ballScrewData.screw.translation.y + 160 * this.quoteScale - 20, BallScrewElement_1.BallScrewElement.STYLE_CENTER);
        this.ballScrewData.ballScrew.add(this.quoteTotal.text);
    }
}
exports.BallScrew = BallScrew;
// BallScrewStyle
BallScrew.DrawerStyle = Object.freeze({
    DOCUMENT: Symbol("document"),
    DRAWER: Symbol("drawer"),
});
